import cleaning from '../Pictures/Gallery/Welfare/cleaning.jpeg'

export const News =[

/* Template
    {
        id: 1,
        image: logo,
        headline: 'General Meeting March 16 2024',
        date: 'March 16 2024',
        time: '18:00',
        sort: new Date('March 16 2024'),
        location:'Via Zoom',
        details:<ul>
            <li><h3>Agenda 1</h3></li>
            <br/>
            <li><h3>Agenda 2</h3></li>
        </ul>
    },
*/



{
    id:1,
    image: cleaning,
    headline:'Ghana Union Czech Republic Joins Uklidíme Česko for Habrovka Forest Cleanup',
    date:'September 2026',
    short:'The Ghana Union Czech Republic participated in a community cleanup exercise organized by the Czech NGO Uklidíme Česko on September 20, 2026, at the Habrovka forest in Krč.',
    sort: new Date('December 31 2027'),
    details:<>
    <p>The Ghana Union Czech Republic took part in a community cleanup exercise organized by the Czech NGO Uklidíme Česko on September 20, 2026. <br/>
The activity was held at the Habrovka forest in Krč, where volunteers from the Union joined other participants to clear litter and help preserve the beauty of natural environment.
<br/>
The Union’s involvement is not only to promote community integration and involvement but also highlights its commitment to  environmental responsibility.
<br/>
The volunteers Members expressed appreciation for the opportunity to contribute to maintaining one of Prague’s cherished green spaces.
</p>
</>
}


]